// Checks if a user is in the European Economic Area (EEA), meaning they are covered by the GDPR

import { getCookie } from "../../../../common/cookie-util";

// Copied from Powa
export function isEEA() {
  if (typeof document === "undefined") {
    return false;
  }
  const wpGeo = getCookie("wp_geo") || "";
  return wpGeo.toUpperCase().endsWith("|EEA");
}
